import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {ProviderEventStatusBadgeVariant, resolveProviderEventStatusBadge,} from '../../../services/vte/vte.constants';

@Component({
    selector: 'app-provider-event-status-badge',
    standalone: true,
    imports: [CommonModule],
    template: `
        <span *ngIf="badge as resolved" class="provider-event-status-badge" [ngClass]="resolved.variant">
            {{ resolved.label }}
        </span>
    `,
    styles: [`
        .provider-event-status-badge {
            display: inline-flex;
            align-items: center;
            padding: 0.2rem 0.55rem;
            border-radius: 999px;
            font-size: 0.72rem;
            font-weight: 700;
            letter-spacing: 0.04em;
            text-transform: uppercase;
            line-height: 1.2;
            white-space: nowrap;
        }

        .provider-event-status-badge.received { background: #E0E7FF; color: #4338CA; }
        .provider-event-status-badge.pending { background: #FEF3C7; color: #D97706; }
        .provider-event-status-badge.matched { background: #DBEAFE; color: #1D4ED8; }
        .provider-event-status-badge.timed_out { background: #F3F4F6; color: #6B7280; }
        .provider-event-status-badge.completed { background: #DCFCE7; color: #16A34A; }
        .provider-event-status-badge.neutral { background: #E5E7EB; color: #374151; }
    `],
})
export class ProviderEventStatusBadgeComponent {
    @Input() status: string | null | undefined = '';

    get badge(): { label: string; variant: ProviderEventStatusBadgeVariant } | null {
        return resolveProviderEventStatusBadge(this.status);
    }
}
